/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { addOrUpdateRNLTD } from '../../../../assets/ts/data/rnltd'
import { scrollToTop } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputSelect from '../../../../utils/controls/input-select'
import InputText from '../../../../utils/controls/input-text'
import { IsArchived } from '../../../../utils/controls/select-options-data'

interface Props {
  allRNLTD: number[]
  cancel: () => void
  clickedIndex?: any
  editItems: any
  fetchMetdata: () => void
  filtersvalue: any
  rnltdCount: number
  showAddPopup: boolean
  showEdit?: any
  toggleView: () => void
}

const AddEditView = ({
  allRNLTD,
  cancel,
  clickedIndex,
  editItems,
  fetchMetdata,
  filtersvalue,
  rnltdCount,
  showAddPopup,
  showEdit,
  toggleView,
}: Props) => {
  if (showAddPopup) {
    scrollToTop()
  }
  const [alertMessage, setAlertMessage] = useState('')
  const [showAlert, setShowAlert] = useState(false)

  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)
  const [changedArchived, setChangedArchived] = useState<boolean>(false)
  const [displayAlert, setDisplayAlert] = useState(false)

  const [inputValues, setInputValues] = useState({
    Archived: editItems?.IsArchived ? editItems.IsArchived : false,
    IntervalDuration: editItems?.IntervalDuration ? editItems.IntervalDuration : '',
  })

  const [rnltdValidations, setRNLTDValidations] = useState({
    Duration: false,
    TitleMsg: '',
  })
  const titleRef: any = useRef<any>(null)
  const descriptionRef = useRef<any>(null)

  useEffect(() => {
    const titleElemnt = document.getElementById('IntervalDuration')
    if (titleRef?.current && titleElemnt) {
      if (clickedIndex === 0) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'end' })
        titleElemnt.focus()
      } else if (clickedIndex === 1) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'nearest' })
        titleElemnt.focus()
      } else {
        titleRef?.current?.scrollIntoView(false)
        titleElemnt.focus()
      }
    }
  }, [titleRef, showEdit, descriptionRef])

  const handleChange = (key: string, value: boolean | number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const changeArchived = (e: { label: string; value: string }) => {
    handleChange('Archived', e.value)
    if (inputValues.Archived !== e.value) {
      setChangedArchived(true)
    } else {
      setChangedArchived(false)
    }
  }

  const saveRNLTD = async () => {
    const userdetails = mpfRListsHttp().me()
    setShowPageOverlay(true)
    const userId = (await userdetails).userId
    const currentDate = new Date()

    const addUpdateObj = {
      IntervalDuration: inputValues.IntervalDuration,
      IntervalFrequency: editItems?.IntervalFrequency ? editItems.IntervalFrequency : 'Days',
      IntervalType: editItems?.IntervalType ? editItems.IntervalType : 'Next',
      IsArchived: inputValues.Archived,
      ItemCreated: currentDate,
      ItemCreatedBy: userId,
      ItemModified: currentDate,
      ItemModifiedBy: userId,
      eKey: editItems ? editItems.eKey : '',
      eTag: editItems ? editItems.eTag : '',
    }
    let isNoChangesDetected = false
    if (
      inputValues.IntervalDuration === editItems?.IntervalDuration &&
      inputValues.Archived === editItems?.IsArchived
    ) {
      isNoChangesDetected = true
      setShowAlert(true)
    }

    if (!isNoChangesDetected) {

      try {
        await addOrUpdateRNLTD(addUpdateObj)
        cancel()
      } catch (error) {
        console.error(error)
        cancel()
        setShowPageOverlay(false)
      }
    } else {
      setShowPageOverlay(false)
    }
  }

  const handleSubmit = async () => {
    let isValid = true
    const validations = {
      Duration: false,
      TitleMsg: '',
    }

    if (
      (inputValues.IntervalDuration <= 0 || inputValues.IntervalDuration === '') &&
      !editItems &&
      rnltdCount < 5
    ) {
      isValid = false
      validations.Duration = true
    }
    if (
      !changedArchived &&
      inputValues.IntervalDuration > 0 &&
      allRNLTD.find((rnltd) => inputValues.IntervalDuration !== editItems?.IntervalDuration
        && Number(inputValues.IntervalDuration) === rnltd)
    ) {
      isValid = false
      validations.Duration = true
      validations.TitleMsg = 'This RNLTD already exist. Please enter unique RNLTD name.'
    }
    setRNLTDValidations(validations)

    if (!editItems && rnltdCount >= 5) {
      isValid = false
      setAlertMessage('You already have the maximum number of data.')
      setDisplayAlert(true)
    }

    if (isValid) {
      await saveRNLTD()
      await fetchMetdata()
      //reset input values here
      toggleView()
    }
  }

  const onClickAlert = async () => {
    setShowAlert(false)
  }

  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative border-top1 mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {displayAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={alertMessage}
          onClick={() => {
            setAlertMessage('')
            setDisplayAlert(false)
            cancel()
          }}
          yes='OK'
        />
      )}
      {showAddPopup && (
        <div className='p-3 border-bottom4'>
          <h4
            aria-label=' Add RNLTD'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add RNLTD
          </h4>
        </div>
      )}
      <div className='px-2 py-1'>
        <div className='row'>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}>
            <InputText
              disabled
              formClassName='d-flex flex-column'
              info='Interval Type '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'IntervalType',
                name: ' Interval Type',
                placeholder: 'Next',
              }}
              isInfo
              isMandatory
              label=' Interval Type '
            />
          </div>
          <div
            className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}
            ref={titleRef}
          >
            <InputText
              changeHandler={(e) => handleChange('IntervalDuration', e.target.value)}
              error={rnltdValidations?.Duration}
              formClassName='d-flex flex-column'
              info='Interval Duration  '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'IntervalDuration',
                name: ' Interval Duration ',
                placeholder: 'Enter Duration ',
                value: inputValues?.IntervalDuration,
              }}
              isInfo
              isMandatory
              label=' Interval Duration  '
              type='number'
              uniqueErrormsg={rnltdValidations?.TitleMsg}
              value={inputValues?.IntervalDuration}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}>
            <InputText
              disabled
              formClassName='d-flex flex-column'
              info='Interval Frequency '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' IntervalFrequency ',
                name: ' Interval Frequency',
                placeholder: 'Days',
              }}
              isInfo
              isMandatory
              label=' Interval Frequency '
            />
          </div>
          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2' ref={descriptionRef}>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                  value: inputValues?.Archived,
                }}
                isInfo
                isMandatory
                label='Is Archived'
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={changeArchived}
                options={IsArchived}
                value={inputValues.Archived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {/* Add Section */}
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {/* Edit Section */}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
